module.exports = "../static/images/7464c1.gif";